<div
  class="hd-moon-transit-card-layer"
  (pointermove)="onLayerPointerMove($event)"
  (pointerup)="onLayerPointerUp($event)"
  (pointercancel)="onLayerPointerUp($event)"
>
  @for (stack of renderStacks(); track stack.key) {
    <div
      class="hd-moon-transit-stack"
      [class.hd-moon-transit-stack--grid]="stack.layout === 'grid'"
      [class.hd-moon-transit-stack--dragging]="stackHasDrag(stack)"
      [style.left.%]="stackLeftPercent(stack)"
      [style.top.%]="stackTopPercent(stack)"
      [style.transform]="stackTransform(stack)"
    >
      @if (moveToolActive() && isPinned(stack)) {
        <span class="moon-transit-pin-dot" aria-hidden="true"></span>
      }
      @for (card of stack.cards; track card.key) {
        <button
          type="button"
          class="hd-moon-transit-card"
          [class.is-highlighted]="highlightedChannelKeys().has(card.key)"
          [class.is-dragging]="isDragging(card)"
          [style.background]="card.typeColor"
          [style.transform]="cardTransform(card)"
          (pointerdown)="onCardPointerDown(card, $event)"
          (dblclick)="onCardDblClick(card)"
          (click)="onCardClick(card.formation, $event)"
          (mouseenter)="onCardEnter(card.formation)"
          (mouseleave)="onCardLeave()"
        >
          @if (card.fixations.length > 0 || card.showBridge) {
            <span class="hd-moon-transit-card__badges">
              @for (fixation of card.fixations; track fixation.key) {
                <span
                  class="hd-moon-transit-card__fixation"
                  [class.hd-moon-transit-card__fixation--design]="fixation.isDesign"
                  [title]="fixation.title"
                >
                  <span class="hd-moon-transit-card__fixation-glyph" aria-hidden="true">{{ fixation.glyph }}</span>{{ fixation.arrow }}
                </span>
              }
              @if (card.showBridge) {
                <i eIcon icon="bridge" class="hd-moon-transit-card__bridge" [title]="card.bridgeTooltip"></i>
              }
            </span>
          }
          <span class="hd-moon-transit-card__main">
            <span class="hd-moon-transit-card__title">{{ card.title }}</span>
            @if (card.keynote) {
              <span class="hd-moon-transit-card__keynote">{{ card.keynote }}</span>
            }
          </span>
          @if (card.centerIcons.length > 0) {
            <span class="hd-moon-transit-card__centers">
              @for (icon of card.centerIcons; track icon.label) {
                <span class="hd-moon-transit-card__center-icon" [title]="icon.label" [innerHTML]="icon.html"></span>
              }
            </span>
          }
        </button>
      }
    </div>
  }
</div>
